export class CreateApplicationProfessionalBodiesBpamsConstants {
    static STEP_TITLE = "Professional bodies";
    static PROFESSIONAL_BODY_FORM_CONTROL_NAME = "professionalBodiesForm";
    static COMPONENT_NAME = "professional-bodies";
    static MARK_ARCHITECT_AS_REQUIRED_LABEL = "Are the architect's details required?";
    static MARK_ARCHITECT_AS_REQUIRED_FORM_CONTROL_NAME = "markArchitectAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ARCHITECT_LABEL = "Copy applicant details to architect?";
    static COPY_APPLICANT_DETAILS_TO_ARCHITECT_FORM_CONTROL_NAME = "copyApplicantToArchitect";
    static MARK_ENGINEER_REQUIRED_LABEL = "Are the civil engineer's details required?";
    static MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME = "markEngineerAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL = "Copy applicant details to civil engineer?";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME = "copyApplicantToEngineer";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL = "Are the electrical contractor's details required?";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME = "markElectricalContractorAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL = "Copy applicant details to electrical contractor?";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "copyApplicantToContractor";
    static MARK_FIRE_CONSULTANT_AS_REQUIRED_LABEL = "Are the fire consultant's details required?";
    static MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markFireConsultantAsRequired";
    static COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_LABEL = "Copy applicant details to fire consultant?";
    static COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_FORM_CONTROL_NAME = "copyApplicantToFireConsultant";
    static MARK_OTHER_PROFESSIONAL_AS_REQUIRED_LABEL = "Are the other professional's details required?";
    static MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markOtherProfessionalAsRequired";
    static COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_LABEL = "Copy applicant details to other professional?";
    static COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_FORM_CONTROL_NAME = "copyApplicantToOtherProfessional";
    static ARCHITECT_LABEL = "Architect";
    static ENGINEER_LABEL = "Engineer";
    static ELECTRICAL_CONTRACTOR_LABEL = "Electrical contractor";
    static FIRE_CONSULTANT_LABEL = "Fire Consultant";
    static OTHER_PROFESSIONAL_LABEL = "Other Professional";
    static ARCHITECT_FORM_CONTROL_NAME = "architectRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "electricalContractorRecipient";
    static FIRE_CONSULTANT_FORM_CONTROL_NAME = "fireConsultantRecipients";
    static OTHER_PROFESSIONAL_FORM_CONTROL_NAME = "otherProfessionalRecipients";
}
